export default {
    CV_SKIP_TELL_US_ABOUT_YOU: "skipTellUsAboutYou",
    CV_SKIP_MS_LOCATION: "skipTeamsCallingLocation",
    CV_SKIP_WELCOME: "skipWelcome",
};
